import { useMutation } from '@tanstack/react-query';
import * as Api from '../api';
import { useAuthContext } from '../context';

export const useRemovePhone = () => {
  const {
    state: { user },
    methods: { setUser },
  } = useAuthContext();

  return useMutation({
    mutationFn: async () => {
      const { data } = await Api.RemovePhone();
      return data;
    },
    onSuccess: () => {
      if (user) {
        setUser({ ...user, phone: undefined, isPhoneVerified: false });
      }
    },
  });
};
